import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material'

const DeleteConfirmDialog = ({
  open,
  conversation,
  onClose,
  onConfirm,
  type = 'single',
}) => {
  if (type === 'single') {
    return (
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>Eliminare Conversazione?</DialogTitle>
        <DialogContent>
          <Typography>
            Sei sicuro di voler eliminare la conversazione intitolata "
            {conversation?.title}"? Questa azione non può essere annullata.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="inherit">
            Annulla
          </Button>
          <Button onClick={onConfirm} color="error" variant="contained">
            Elimina
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Eliminare Tutte le Chat?</DialogTitle>
      <DialogContent>
        <Typography>
          Sei sicuro di voler eliminare TUTTE le tue conversazioni? Questa azione è
          permanente e non può essere annullata.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Annulla
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          Elimina Tutto
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteConfirmDialog
